/**
 * React hook for fetching case list from lexserver.
 * Uses TanStack Query for caching, refetching, and error handling.
 */

import { useQuery } from "@tanstack/react-query";
import { fetchCases, type CaseListItem } from "@/lib/lexserver-client";

interface UseCasesOptions {
  /** Skip the network call when false. Defaults to true. */
  enabled?: boolean;
}

export function useCases(options: UseCasesOptions = {}) {
  const { enabled = true } = options;
  return useQuery<CaseListItem[], Error>({
    queryKey: ["cases"],
    queryFn: fetchCases,
    staleTime: 60_000, // 1 minute
    retry: 2,
    enabled,
  });
}
